import { Exclude } from 'class-transformer';

export class WorkOrderLineItemRawDto {
    crudAction: string;
    workOrderItemId: number;
    description: string;
    serviceCode: string;
    amount: number;

    @Exclude()
    id: number;
}
